import React from 'react'
import "../CSS/Template/Projects.css"
import { Helmet } from 'react-helmet'
import FooTer from "./footer"
import { Link } from 'react-router-dom';


export default function Projects(props) {

    return (
        <>
            <Helmet>
                <title>Code Arindam | Projects</title>
            </Helmet>
            {props.setProgress(0)}
            <div id="Projects">
                <div className='mainDiv'>
                    <p className='mainText'>KURO THE VOICE ASSISTANCE</p>
                    <p className="describe">
                        Kuro The Voice Assistance is a voice assistance like google assistance also this can speech with created in react JS.
                    </p>
                    <div className="sourceBtn">
                        <a target="_blank" rel="noreferrer" href="https://github.com/Arindamk143/Kuro-Assistance/">Open Code</a>
                        <a target="_blank" rel="noreferrer" href="https://arindamk143.github.io/Kuro-Assistance/">Open Website</a>
                    </div>
                </div>
                {props.setProgress(25)}
                <div className='mainDiv'>
                    <p className="mainText">
                        Text Editions Best Text Editions
                    </p>
                    <p className="describe">
                        Here you guys could be do copy, edit, upper case, capitilize Case, Lower Case Etc Editions could be do Text Articals with a best text edition you shown.<br />
                        This Website created on React Native So Don't Forget To Visit...
                    </p>
                    <div className="sourceBtn">
                        <a target="_blank" rel="noreferrer" href="https://github.com/Arindamk143/text-edit">Open Code</a>
                        <a target="_blank" rel="noreferrer" href="https://arindamk143.github.io/text-edit/">Open Website</a>
                    </div>
                </div>
                {props.setProgress(50)}
                <div className='mainDiv'>
                    <p className="mainText">
                        Text To Speech Convertor
                    </p>
                    <p className="describe">
                        Text2Speech website here you can tye anything in this website but all of the your text converts to voice you could listen here every story just copy your text line and submit and then injoy also here pause and resume buttons availabe.<br />
                        This Website Also Created On React Native. So Guy Visit Now And Injoy In This Site...
                    </p>
                    <div className="sourceBtn">
                        <a target="_blank" rel="noreferrer" href="https://github.com/Arindamk143/Text2Speech">Open Code</a>
                        <a target="_blank" rel="noreferrer" href="https://arindamk143.github.io/Text2Speech/">Open Website</a>
                    </div>
                </div>
                {props.setProgress(75)}
                <div className='mainDiv'>
                    <p className="mainText">
                        Rakhi Bandhan In 2022
                    </p>
                    <p className="describe">
                        In This Website You Could Be Show Your Name In Best Rakhi Images So Suprise Your Friends And Family.<br />
                        Happy Rakhsha Bandhan.
                    </p>
                    <div className="sourceBtn">
                        <a target="_blank" rel="noreferrer" href="https://github.com/Arindamk143/Rakhi-Celibration/">Open Code</a>
                        <a target="_blank" rel="noreferrer" href="https://arindamk143.github.io/Rakhi-Celibration/">Open Website</a>
                    </div>
                </div>
                <div className='mainDiv'>
                    <p className="mainText">
                        Independence Day In 2022
                    </p>
                    <p className="describe">
                        Surprice your friends and everyone with the indepence day website here you could be injoy a greatly music and random images. <br />
                        Happy Independence Day.
                    </p>
                    <div className="sourceBtn">
                        <a target="_blank" rel="noreferrer" href="https://github.com/Arindamk143/independence-day">Open Code</a>
                        <a target="_blank" rel="noreferrer" href="https://arindamk143.github.io/independence-day/">Open Website</a>
                    </div>
                </div>
            <hr style={{backgroundColor:"white"}}/>
                <div className="page">
                    <Link to="/Projects">&laquo;</Link>
                    <Link to='/Projects' className='active' >1</Link>
                    <Link to='/Projects/Page-2'>2</Link>
                    <Link to='/Projects/Page-3'>3</Link>
                    <Link to="/Projects/Page-2">&raquo;</Link>
                </div>
            </div>
            <hr style={{backgroundColor:"white"}}/>
            <FooTer />
            {props.setProgress(100)}
        </>
    )
}
